import { motion } from 'framer-motion';

export default function Booking() {
  return (
    <section
      id="book"
      data-testid="booking-section"
      className="py-24 px-6 lg:px-10 bg-[#FAFAF7]"
    >
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A1628]/40 mb-4">
            Book a call
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#0A1628]">
            Pick a time that works for you
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="bg-white rounded-2xl shadow-[0_8px_40px_rgba(10,22,40,0.07)] overflow-hidden"
          style={{ height: '480px', position: 'relative' }}
        >
          <iframe
            src="https://tidycal.com/macey1/book-a-time-for-us-to-chat-about-your-business-and-how-we-help-subscription-brands-reduce-cancellations-1-on-1-15-minutes-no-commitment"
            title="Book a call"
            width="100%"
            height="800"
            frameBorder="0"
            style={{
              display: 'block',
              position: 'absolute',
              top: '-308px',
              left: 0,
              width: '100%',
            }}
          />
        </motion.div>
      </div>
    </section>
  );
}
